<ul id="MySummaryViewUL" class="summary-view">

  @for (item of dataLst(); track item; let i = $index) {
    <li>
      {{item.entitlementGroupName}}
    </li>
  }
</ul>